import {createSlice} from '@reduxjs/toolkit'
import {fetchReportData} from './actions/reportAction'

const initialState = {
  reportData: null,
  blendedData: null,
  loading: false,
  error: null,
}

export const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchReportData.pending]: (state) => {
      state.loading = true
      state.error = null
    },
    [fetchReportData.fulfilled]: (state, {payload}) => {
      state.loading = false
      state.reportData = payload.reportData
      state.blendedData = payload.blendedData // Store blendedData
      state.insuranceDetails = payload.insuranceDetails
      state.orderConversionDetails = payload.orderConversionDetails
    },
    [fetchReportData.rejected]: (state, {payload}) => {
      state.loading = false
      state.error = payload
    },
  },
})

export default reportSlice.reducer
